<template>
  <div class="form-w">
    <!-- Exit Pop Out -->
    <pop-window
      :showAddPop="showExitPop"
      :showAddPopW="showExitPop"
      popTitle="Exit Editor"
      popDescription="Save your changes before leaving?"
      primaryButtonText="Save"
      plainButtonText="Discard"
      secondaryButtonType="danger"
      @close-pop="closeExitPop()"
      @primary-func="saveChanges()"
      @secondary-func="$store.dispatch('closeItemEditor')"
      v-if="showExitPopW"
    ></pop-window>

    <!-- Exit editor and button sets at top -->
    <div class="top-nav">
      <div class="back-w" @click="closeEditor()">
        <i class="el-icon-back"></i>
      </div>
      <div :class="offsetY < 58 ? 'button-set top-set' : 'button-set top-set top-fixed'">
        <el-button type="primary" round :disabled="!hasChange" @click="saveChanges()" style="margin-top: 12px;">Save</el-button>
        <el-button type="primary" round plain :disabled="!hasChange" @click="saveChangesCopy()" style="margin-top: 12px;">Add Copy</el-button>
        <el-button type="primary" round plain :disabled="!hasChange" @click="saveChangesNew()" style="margin-top: 12px;">Add New</el-button>
      </div>
    </div>

    <div class="form-loader-w">

    <!-- Item index -->
    <div class="item-index">
      <div class="index-number">{{ editingForm.index }} / {{currentFolderSize}}</div>
      <div class="index-adjust-button" @click="addIndex()"><span class="symbol">+</span></div>
      <div class="index-adjust-button" @click="minusIndex()"><span class="symbol">-</span></div>
    </div>
    <div class="index-warning" v-show="manualIndexWarning"><i class="material-icons">warning</i>Use custom index is not recommended.</div>

    <!-- Item mark -->
    <div class="form-name">
      <div class="error-tip" v-if="noItemName">Item name is requried</div>
      <div class="main-title">Mark</div>
      <el-input v-if="editingForm !== null" v-model="editingForm.name" @focus="noItemName = false" clearable></el-input>
    </div>

    <!-- Item RF -->
    <div class="form-name">
      <div class="main-title">RF</div>
      <el-input v-if="editingForm !== null" v-model="editingForm.rf" @focus="noItemName = false" clearable></el-input>
    </div>

    <!-- Item questions-->
    <div class="form-name" v-for="(question,index) in editingForm.questions" :key="index">
      <div class="error-tip" v-show="requireValidation[index] === false">Below is a required filed</div>
      <question-loader v-model="editingForm.questions[index]" v-on:focused="removeRequiredError(index)"></question-loader>
    </div>

    <!-- Item images -->
    <div class="error-w">
      {{formError}}
    </div>
    <div>Images For this item</div>
    <div class="image-upload-tip">
      TIP: Newly added image will be saved to item only after you save the form.
    </div>
    <item-image-input v-model="editingForm.images"></item-image-input>

    </div>

    <!-- Button sets at bottom -->
    <!-- <div class="button-set bottom-set">
      <el-button type="primary" round :disabled="!hasChange" @click="saveChanges()" style="margin-top: 12px;">Save</el-button>
      <el-button type="primary" round plain :disabled="!hasChange" @click="saveChangesCopy()" style="margin-top: 12px;">Add Copy</el-button>
      <el-button type="primary" round plain :disabled="!hasChange" @click="saveChangesNew()" style="margin-top: 12px;">Add New</el-button>
    </div> -->
    <div style="height: 80px"></div>

    <div class="to-top" @click="scrollToTop()">
      <i class="material-icons">vertical_align_top</i>
    </div>
  </div>
</template>

<script>
import QuestionLoader from './QuestionLoader.vue'
import ItemImageInput from './ItemImageInput.vue'
import PopWindow from './PopWindow.vue'

export default {
  name: 'FormLoader',
  components: { QuestionLoader, ItemImageInput, PopWindow },
  props: ['formInstance'],
  data () {
    return {
      stringifyForm: JSON.stringify(this.formInstance),
      editingForm: null,
      hasChange: true,
      formError: '',
      requireValidation: [],
      noItemName: false,
      suggestedIndex: null,

      showExitPopW: false,
      showExitPop: false,

      offsetY: 0
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  created: function () {
    // console.log(this.editingForm)
    this.editingForm = JSON.parse(this.stringifyForm)
    this.suggestedIndex = this.editingForm.index
  },
  computed: {
    currentFolderSize: function () {
      return this.$store.getters.nextItemIndex - 1
    },
    manualIndexWarning: function () {
      return this.editingForm.index !== this.suggestedIndex
    }
  },
  methods: {
    handleScroll: function (e) {
      this.offsetY = window.pageYOffset
    },
    scrollToTop: function () {
      window.scrollTo(0, 0)
    },
    closeEditor: function () {
      this.showExitPopW = true
      setTimeout(() => {
        this.showExitPop = true
      }, 100)
      // let that = this
      // if (!this.hasChange) {
      //   this.$store.dispatch('closeItemEditor')
      //   return
      // }
      // this.$confirm('Save your change before closing?', 'Exist Editor', {
      //   confirmButtonText: 'Save',
      //   cancelButtonText: 'Discard',
      //   type: 'warning'
      // }).then(() => {
      //   that.saveChanges()
      // }).catch(() => {
      //   this.$store.dispatch('closeItemEditor')
      // })
    },
    closeExitPop: function () {
      this.showExitPop = false
      this.showExitPopW = false
      // setTimeout(() => {
      //   this.showExitPopW = false
      // }, 1000)
    },
    saveChanges: async function () {
      if (!this.validRequired()) {
        this.formError = 'Some required fields are blank'
        return
      }
      let itemToSave = JSON.parse(JSON.stringify(this.editingForm))
      let saveRequest = {
        itemToSave: itemToSave,
        nextItem: null
      }

      let saveResult = await this.$store.dispatch('saveItemChange', saveRequest)
      if (saveResult.success) {
        this.$message.success('Saved!')
        window.scrollTo(0, 0)
      } else {
        this.$message.error('Network error, please try again')
      }
    },
    saveChangesCopy: async function () {
      if (!this.validRequired()) {
        this.formError = 'Some required field is blank'
        return
      }
      let itemToSave = JSON.parse(JSON.stringify(this.editingForm))
      let saveRequest = {
        itemToSave: itemToSave,
        nextItem: ''
      }

      let saveResult = await this.$store.dispatch('saveItemChange', saveRequest)
      if (saveResult.success) {
        this.$message.success('Saved!')
        window.scrollTo(0, 0)
      } else {
        this.$message.error('Network error, please try again')
      }
    },
    saveChangesNew: async function () {
      if (!this.validRequired()) {
        this.formError = 'Some required field is blank'
        return
      }
      let itemToSave = JSON.parse(JSON.stringify(this.editingForm))
      let saveRequest = {
        itemToSave: itemToSave,
        nextItem: 'New' + itemToSave.templateName
      }

      let saveResult = await this.$store.dispatch('saveItemChange', saveRequest)
      if (saveResult.success) {
        this.$message.success('Saved!')
        window.scrollTo(0, 0)
      } else {
        this.$message.error('Network error, please try again')
      }
    },
    validRequired: function () {
      let allPass = true
      // console.log('valid the form')
      // Name is oprtional
      // if (!this.editingForm.name) {
      //   allPass = false
      //   this.noItemName = true
      // }
      for (let i = 0; i < this.editingForm.questions.length; i++) {
        let question = this.editingForm.questions[i]
        if (!question.required) {
          // console.log('Bypass')
          this.requireValidation[i] = true
        } else {
          // console.log(question)
          if (typeof question.value === 'string') {
            // console.log('test string')
            question.filled = !!question.value
            // console.log(question)
            this.requireValidation[i] = question.filled
          } else if (Array.isArray(this.question.value)) {
            // console.log('test array')
            question.filled = question.value[0] !== ''
            this.requireValidation[i] = question.filled
          } else {
            // console.log('no value type')
            question.filled = true
            this.requireValidation[i] = true
          }
          // console.log(question.filled)
          allPass = allPass && question.filled
        }
      }
      this.$forceUpdate()
      return allPass
    },
    removeRequiredError: function (index) {
      // console.log('remove required error')
      this.requireValidation[index] = true
      this.$forceUpdate()
    },
    addIndex: function () {
      this.editingForm.index++
    },
    minusIndex: function () {
      this.editingForm.index = this.editingForm.index <= 1 ? 1 : this.editingForm.index - 1
    }
  }
}

// function buildForm (formSeed, questionBase) {
//   let form = {
//     name: formSeed.name,
//     questions: []
//   }
//   let questionSN = 1
//   for (let questionID of formSeed.questionIDs) {
//     let questionInstance = questionBase.find(question =>  question.id === questionID)
//     if (questionInstance !== undefined) {
//       questionInstance.sn = questionSN
//       questionSN += 1
//       form.questions.push(questionInstance)
//     }
//   }
//   return form
// }
</script>

<style scoped>

.el-button+.el-button {
  margin-left: 20px !important;
}

.to-top {
  position: fixed;
  bottom: 24px;
  right: calc((100vw - 744px) / 2);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #ffffff;
  box-shadow: 0 1px 3px 0 #969696;
  box-sizing: border-box;
  padding: 14px 12px 10px 12px;
  cursor: pointer;
  z-index: 999;
}

.main-title {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 4px;
  margin-left: 4px;
  margin-top: 12px;
}

.form-loader-w {
  box-sizing: border-box;
  padding: 32px 16px 42px 16px;
  max-width: 600px;
  width: 100%;
  margin: auto;
  background-color: rgba(64, 158, 255, 0.08);
  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.2);
  border-radius: 5px;
}
.form-name {
  margin: 8px 0 24px 0;
}

.top-nav {
  box-sizing: border-box;
  padding: 32px 0 32px 0;
  max-width: 600px;
  width: 100%;
  margin: auto;
}

.back-w {
  height: 48px;
  line-height: 48px;
  width: 48px;
  text-align: center;
  border-radius: 50%;
  font-size: 20px;
  margin-right: 12px;
  margin-bottom: 0;
  box-sizing: border-box;
  padding-top: 1px;
  display: inline-block;
}
.error-tip {
  font-size: 14px;
  font-weight: 21px;
  margin: 4px 0 4px 4px;
  font-weight: bold;
  color: red;
}
.error-w {
  font-size: 14px;
  line-height: 21px;
  margin: 4px 0 4px 4px;
  font-weight: bold;
  color: red;
}
.button-set {
  margin-top: 24px;
  margin-left: 4px;
  text-align: center;
}

.bottom-set {
  box-sizing: border-box;
  margin: 32px auto 80px auto;
  max-width: 600px;
  width: 100%;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 12px 16px 20px 16px;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.12);
  border-radius: 5px;
}

.top-set {
  /* width: calc(100% - 60px); */
  box-sizing: border-box;
  margin: 0 auto 0 auto;
  max-width: 600px;
  width: 100%;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 12px 16px 20px 16px;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.12);
  border-radius: 5px;
  /* display: inline-block; */
}

.top-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  max-width: 100vw;
  z-index: 8;
  transition: all 0.2s;
}

.item-index {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.index-number {
  font-size: 2em;
  font-weight: bold;
  color: #1e88e5;
  margin-right: 24px;
}

.index-adjust-button {
  border-radius: 16px;
  border: solid 1px #1e88e5;
  font-size: 36px;
  font-weight: bold;
  color: #1e88e5;
  width: 48px;
  height: 48px;
  margin-right: 18px;
  cursor: pointer;
  text-align: center;
  vertical-align: middle;
}

.index-adjust-button:hover {
  border-radius: 8px;
  border: solid 1px #1e88e5;
  font-size: 36px;
  font-weight: bold;
  color: #ffffff;
  background-color: #1e88e5;
  width: 48px;
  height: 48px;
  margin-right: 18px;
  cursor: pointer;
}

.symbol {
  display: inline-block;
  margin-top: 2px;
}

.index-warning {
  color: #f8ac07;
  vertical-align: middle;
}

.image-upload-tip {
  font-size: 14px;
  line-height: 21px;
  margin: 8px 0 12px 0;
  color: #969696;
}

@media screen and (max-width: 991px) {
  .el-button+.el-button {
    margin-left: 20px !important;
  }

  .form-w {
    width: 100vw;
    overflow-x: hidden;
  }

  .form-loader-w {
    border-radius: 5px;
  }

  .top-nav {
    box-sizing: border-box;
    padding: 12px 0 16px 0;
    max-width: 600px;
    width: 100%;
    margin: auto;
  }

  .top-set {
    padding: 12px 16px 20px 16px;
    border-radius: 5px;
  }

  .bottom-set {
    margin-top: 16px;
    border-radius: 5px;
  }
}

@media screen and (max-width: 792px) {
  .el-button+.el-button {
    margin-left: 12px !important;
  }

  .to-top {
    right: calc((100vw - 564px) / 2);
    bottom: 16px;
  }
}

@media screen and (max-width: 600px) {
  .to-top {
    right: 12px;
    bottom: 16px;
  }

  .el-button+.el-button {
    margin-left: 10px !important;
  }

  .form-loader-w {
    border-radius: 0;
  }

  .top-set {
    padding: 12px 16px 20px 16px;
    border-radius: 0;
  }

  .bottom-set {
    border-radius: 0;
  }
}

@media screen and (max-width: 350px) {
  .el-button+.el-button {
    margin-left: 4px !important;
  }
  .top-set {
    padding: 12px 0 20px 0;
  }
}
</style>
